import Vue from 'vue';
import Vuex from 'vuex';
import { accountModule as account } from '@/store/accountModule';
import { userModule as user } from '@/store/userModule';
import { versionModule as version } from '@/store/versionModule';
import { resourceModule as resource } from '@/store/resource/resourceModule';
import { coursewareModule as courseware } from '@/store/courseware/coursewareModule';
import { experimentModule as experiment } from '@/store/experiment/experimentModule';
import { encryptionModule as encryption } from '@/store/encryptionModule';
import { langModule as lang } from '@/store/langModule';
import { caseModule } from '@/store/case/caseModule';
import { questionModule as question } from '@/store/question/questionModule';
import {suitModule as suit} from '@/store/suitModule';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    account,
    user,
    version,
    resource,
    courseware,
    experiment,
    encryption,
    lang,
    caseModule,
    question,
    suit
  }
})
